
















































































import Vue from 'vue'
import ModalSimple from '@/common/components/ModalSimple.vue'
import FilterSearchModal from '@/categories/components/FilterSearchModal.vue'
import FilterFacetsModal from '@/categories/components/FilterFacetsModal.vue'
import { SearchFacets } from '@/search/types'
import { CurrentCategory } from '@/model/category'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'

enum ActiveMenuState {
  MAIN = 'main',
  SEARCH = 'search',
  FACETS = 'facets'
}
export default Vue.extend({
  components: {
    ModalSimple,
    FilterSearchModal,
    FilterFacetsModal
  },
  props: {
    currentCategory: {
      type: Object  as () => CurrentCategory,
      required: true
    },
    facetData: {
      type: Array as () => SearchFacets[],
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data(): {
    activeMenu: ActiveMenuState,
    searchTypeTitle: string,
    selectedFacetDataItem: SearchFacets | undefined,
  } {
    return {
      activeMenu: ActiveMenuState.MAIN,
      searchTypeTitle: '数量・単価で絞り込む',
      selectedFacetDataItem: undefined
    }
  },
  computed: {
    isMainView(): boolean {
      return this.activeMenu == ActiveMenuState.MAIN
    },
    isSearchView(): boolean {
      return this.activeMenu == ActiveMenuState.SEARCH
    },
    isFacetsView(): boolean {
      return ![ActiveMenuState.MAIN,ActiveMenuState.SEARCH].includes(this.activeMenu)
    },
    menuType(): string {
      return this.isFacetsView ? ActiveMenuState.FACETS : this.activeMenu
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    selectedFacetData( facet: SearchFacets) {
      this.activeMenu = ActiveMenuState.FACETS
      this.selectedFacetDataItem = facet
    },
    changeToSearchModal() {
      this.activeMenu = ActiveMenuState.SEARCH
    },
    goToMainMenu() {
      this.activeMenu = ActiveMenuState.MAIN
    }
  }
})
